import React from 'react';
import { useParams } from 'react-router-dom';
import SmsSetupHeader from './components/SmsSetupHeader';
import SmsSetupBody from './components/SmsSetupBody';

const SmsSetup: React.FC<{}> = () => {
  const { smsCommunicationId } = useParams<{ smsCommunicationId: string }>();

  const headerText = smsCommunicationId ? 'View SMS Communication' : 'Create SMS Communication';

  return (
    <div className="scaleui scale-tailwind flex flex-col h-full w-full items-center">
      <SmsSetupHeader text={headerText} />
      <SmsSetupBody smsCommunicationId={smsCommunicationId} />
    </div>
  );
};

export default SmsSetup;
